import React, { Component } from 'react';
import { Loader, Radio, RadioSize } from '../Helpers/Helpers';
import {
	fabric
} from 'fabric';
var FontFaceObserver = require('fontfaceobserver');

//var plauqeData = {};
var q = Math.PI / 180;
var plauqeGroup;
var canvas

var plaqueInit = { text: "Type something", font: 'Arial', fontSize: 28, bottomMargin: 0, bold: false, italic: false, underline: false, align: 'center' };

var fonts = ["Arial", "Merlin", "Comic Sans", "Harrington", "Black Chancery", "Amaze", "Snell", "Kelt Normal", "Celtic Plain", "DorovarFLF-Carolus", "Times New Roman", "Bookman Old Style", "Lucida Calligraphy", "Monotype Corsiva", "Maiandra GD", "Old English", "Opera"];

class Plaque extends Component {

	constructor(props) {
		super(props);
		this.state = {
			colorStyle: [
				{ id: 1, value: "#DAA520", name: 'Gold' },
				{ id: 2, value: "#C0C0C0", name: 'Silver' }
			],
			sizeStyle: [
				{ id: 1, name: 'small' },
				{ id: 2, name: 'medium' },
				{ id: 3, name: 'large' }
			],
			plaqueSize: 'large',
			colour: '#DAA520',
			plaqueLines: [plaqueInit],
			plaqueUpdated: 0
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.selectedmatBoard !== this.props.selectedmatBoard) {
			this.setPlaque();
		}

		if (prevState.plaqueUpdated !== this.state.plaqueUpdated) {
			this.drawPlaque()
		}
	}

	setPlaque() {
		const {
			selectedmatBoard
		} = this.props;

		if (canvas === undefined && selectedmatBoard.get('has_plaque') === 'yes') {
			//console.log(canvas)
			this.prepareCanvas()
		}
		var self = this;
		var myfont = new FontFaceObserver('Arial')
		myfont.load()
			.then(function () {
				self.drawPlaque()
			}).catch(function (e) {
				console.log(e)
			});

		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				plaqueValues: [plaqueInit]
			}
		})
	}

	handleSizeChange = evt => {
		this.setState({
			plaqueSize: evt.target.value,
			plaqueUpdated: this.state.plaqueUpdated === 1 ? 0 : 1
		});
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				plaqueSize: evt.target.value,
				plaqueUpdated: this.props.plaqueUpdated === 1 ? 0 : 1
			}
		})
	};

	handleColorChange = evt => {
		this.setState({ colour: evt.target.value, plaqueUpdated: this.state.plaqueUpdated === 1 ? 0 : 1 });
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				plaqueColour: evt.target.value,
				plaqueUpdated: this.props.plaqueUpdated === 1 ? 0 : 1
			}
		})
	};

	handleLineChange = idx => evt => {
		const target = evt.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		const newplaqueLines = this.state.plaqueLines.map((plaqueLine, sidx) => {
			if (idx !== sidx)
				return plaqueLine;

			switch (name) {
				case 'text':
					return { ...plaqueLine, text: value };
				case 'font':
					return { ...plaqueLine, font: value };
				case 'fontSize':
					return { ...plaqueLine, fontSize: value };
				case 'bottomMargin':
					return { ...plaqueLine, bottomMargin: value };
				case 'bold':
					return { ...plaqueLine, bold: value };
				case 'italic':
					return { ...plaqueLine, italic: value };
				case 'underline':
					return { ...plaqueLine, underline: value };
				case 'align':
					return { ...plaqueLine, align: value };
				default:
			}
		});
		this.setState({
			plaqueLines: newplaqueLines,
			plaqueUpdated: this.state.plaqueUpdated === 1 ? 0 : 1
		});
		this.updatedPlaqueValues(newplaqueLines)
	};

	updatedPlaqueValues = (value) => {
		var self = this;

		value.forEach(val => {
			var myfont = new FontFaceObserver(val.font)
			myfont.load()
				.then(function () {
					self.props.dispatch({
						type: 'SET_STATE',
						state: {
							plaqueValues: value,
							plaqueUpdated: self.props.plaqueUpdated === 1 ? 0 : 1
						}
					})
				}).catch(function (e) {
					console.log(e)
				});
		});
	}

	handleAddLine = () => {
		this.setState({
			plaqueLines: this.state.plaqueLines.concat([plaqueInit]),
			plaqueUpdated: this.state.plaqueUpdated === 1 ? 0 : 1
		});
		this.updatedPlaqueValues(this.state.plaqueLines.concat([plaqueInit]))
	};

	handleRemoveLine = idx => () => {
		this.setState({
			plaqueLines: this.state.plaqueLines.filter((s, sidx) => idx !== sidx),
			plaqueUpdated: this.state.plaqueUpdated === 1 ? 0 : 1
		});
		this.updatedPlaqueValues(this.state.plaqueLines.filter((s, sidx) => idx !== sidx))
	};

	get ratio() {
		if (parseFloat(this.width) !== 0 && parseFloat(this.height) !== 0)
			return Math.min(555 / this.width, 555 / this.height);
		else
			return 1;
	}

	get q() {
		const { matOuterWidth, matOuterHeight } = this.props;
		if (parseFloat(matOuterWidth) !== 0 && parseFloat(matOuterHeight) !== 0)
			q = Math.min(1e3 / parseFloat(matOuterWidth), 1e3 / parseFloat(matOuterHeight));
		else
			q = 1
		return q;
	}

	get width() {
		const {
			selectedmatBoard
		} = this.props;

		return parseFloat(selectedmatBoard.getIn([this.plaqueSize, 'width'])) * this.q
	}

	get height() {
		const {
			selectedmatBoard
		} = this.props;

		return parseFloat(selectedmatBoard.getIn([this.plaqueSize, 'height'])) * this.q
	}

	get plaqueSize() {
		const {
			plaqueSize
		} = this.state;
		let plaqueParameter = '';
		switch (plaqueSize) {
			case 'small':
				plaqueParameter = 'plaque_data'
				break;
			case 'medium':
				plaqueParameter = 'plaque_medium'
				break;
			case 'large':
				plaqueParameter = 'plaque_large'
				break;
			default:
		}
		return plaqueParameter;
	}

	getDPI() {
		return 96
	}

	pxToFontsize(e) {
		return this.pxToMm(e) / 0.50
	}

	pxToMm(e) {
		return parseFloat((25.4 * e / this.getDPI()).toFixed(1))
	}

	prepareCanvas() {
		canvas = new fabric.Canvas('plaquePreview');
		canvas.selection = false
	}

	drawPlaque() {
		const {
			selectedmatBoard,
			plaqueColour
		} = this.props;

		const {
			plaqueLines
		} = this.state;

		if (selectedmatBoard.get('has_plaque') !== 'yes')
			return;

		canvas.clear();

		/* console.log('-------------------------')
		console.log('this.width: ' + this.width)
		console.log('this.height: ' + this.height)
		console.log('this.ratio: ' + this.ratio)
		console.log('this.q: ' + this.q)
		console.log('-------------------------') */

		canvas.setWidth(this.width * this.ratio);
		canvas.setHeight(this.height * this.ratio);

		var plauqeRects = new fabric.Rect({
			top: 0,
			left: 0,
			width: this.width,
			height: this.height,
			fill: plaqueColour,
			type: 'plauqeRect',
			selectable: false
		});

		if (plaqueLines.length > 0) {
			var plauqeText = [];
			var pHeight = 10;
			var leftSpacing = 10
			for (var i = 0; i < plaqueLines.length; i++) {
				const textAlign = plaqueLines[i]['align']

				switch (textAlign) {
					case 'center':
						leftSpacing = plauqeRects.left + (this.width / 2)
						break;
					case 'left':
						leftSpacing = plauqeRects.left + 5
						break;
					case 'right':
						leftSpacing = plauqeRects.left + (this.width - 10)
						break;
					default:
						break;
				}

				const plauqes = new fabric.Text(plaqueLines[i]['text'], {
					left: leftSpacing,
					originX: textAlign,
					originY: 'center',
					fontSize: this.pxToFontsize(plaqueLines[i]['fontSize']),
					fontFamily: plaqueLines[i]['font'],
					fill: '#000',
					fontWeight: plaqueLines[i]['bold'] ? 'bold' : 'normal',
					underline: plaqueLines[i]['underline'] ? true : false,
					fontStyle: plaqueLines[i]['italic'] ? 'italic' : 'normal',
					selectable: false
				});

				if (plaqueLines.length === 1)
					plauqes.top = plauqeRects.top + (0.5 * this.height)
				else
					plauqes.top = plauqeRects.top + (this.height / (plaqueLines.length * 2)) + pHeight

				plauqeText.push(plauqes);
				const textBoundingRect = plauqes.getBoundingRect();
				pHeight = textBoundingRect.height + pHeight
			}

			var text = new fabric.Group(plauqeText);

			text.type = 'plauqeText'
			plauqeGroup = new fabric.Group([plauqeRects, text]);
		}

		plauqeGroup.hasControls = false;
		plauqeGroup.selectable = false;
		plauqeGroup.type = 'plauqe';

		canvas.add(plauqeGroup);
		// Set canvas zoom
		canvas.setZoom(this.ratio);
		// Render canvas
		canvas.renderAll();
	}

	render() {
		const {
			selectedmatBoard,
			plaqueError
		} = this.props;

		const {
			plaqueLines
		} = this.state;

		return (
			<div className="top_cont sizes-wrapper">
				{selectedmatBoard.size > 0 ?
					<div>
						{selectedmatBoard.get('has_plaque') === 'yes' ?
							<div>
								{plaqueError &&
									<div className="alert alert-danger">The text you have entered exceeds the guidelines. Either change the plaque size, or the font size to fix it.</div>
								}
								<div className="row">
									<div className="col-sm-6">
										<div className="sizes-inner col-sm-12">
											<div className="plaqueWrapper row">
												<div className="col-md-12">
													<span>Size</span>
													<div className="h-size10 clear"></div>
													<ul>
														{this.state.sizeStyle.map((style) => {
															return (<RadioSize key={style.id} handleCheckChildElement={this.handleSizeChange} selectedmatBoard={selectedmatBoard} plaqueSize={this.state.plaqueSize} {...style} />)
														})}
													</ul>
												</div>
												<div className="h-size10 clear"></div>
												<div className="col-md-12">
													<span>Colour</span>
													<div className="h-size10 clear"></div>
													<ul>
														{
															this.state.colorStyle.map((style) => {
																return (<Radio key={style.id} handleCheckChildElement={this.handleColorChange} colour={this.state.colour} {...style} />)
															})
														}
													</ul>
												</div>
											</div>
										</div>
										<div className="col-sm-12">
											<div className="row">
												<div className="plaquePreview">
													<canvas id="plaquePreview"></canvas>
												</div>
											</div>
										</div>
									</div>
									<div className="col-sm-6">
										<div className="sizes-inner col-sm-12">
											{plaqueLines.map((plaqueLine, idx) => (
												<div key={idx} className="plaqueWrapper plaqueLines row">
													<div className="col-md-6">
														<span>{`Line ${idx + 1}`}</span>
													</div>
													{idx > 0 &&
														<div className="col-md-6" style={{ textAlign: 'right' }}>
															<button
																type="button"
																onClick={this.handleRemoveLine(idx)}
																className="btn btn-danger"
															>
																<i className="fa fa-times"></i>
															</button>
														</div>
													}
													<div className="h-size10 clear"></div>
													<div className="col-md-8">
														<label htmlFor="text">Text</label>
														<input type="text" value={plaqueLine.text} className="form-control" name="text" id="text" placeholder="Type something" onChange={this.handleLineChange(idx)} />
													</div>
													<div className="col-md-4">
														<label>Text Alignment</label>
														<ul>
															<li className="radioWrapper">
																<label className={plaqueLine.align === 'left' ? 'active btn' : 'btn'}>
																	<input name={`align`} onChange={this.handleLineChange(idx)} type="radio" checked={plaqueLine.align === 'left'} value={`left`} />
																	<i className={'fa fa-align-left'}></i>
																</label>
															</li>
															<li className="radioWrapper">
																<label className={plaqueLine.align === 'center' ? 'active btn' : 'btn'}>
																	<input name={`align`} onChange={this.handleLineChange(idx)} type="radio" checked={plaqueLine.align === 'center'} value={`center`} />
																	<i className={'fa fa-align-center'}></i>
																</label>
															</li>
															<li className="radioWrapper">
																<label className={plaqueLine.align === 'right' ? 'active btn' : 'btn'}>
																	<input name={`align`} onChange={this.handleLineChange(idx)} type="radio" checked={plaqueLine.align === 'right'} value={`right`} />
																	<i className={'fa fa-align-right'}></i>
																</label>
															</li>
														</ul>
													</div>
													<div className="h-size10 clear"></div>
													<div className="col-md-4">
														<label htmlFor="font">Font</label>
														<select id="font" className="form-control" value={plaqueLine.font} name="font" onChange={this.handleLineChange(idx)}>
															{
																fonts.map((font) => {
																	return (<option style={{ fontFamily: `${font}` }} key={`${font}_key`} value={font}>{font}</option>)
																})
															}
														</select>
													</div>
													<div className="col-md-4">
														<label htmlFor="fontSize">Size</label>
														<select id="fontSize" className="form-control" name="fontSize" value={plaqueLine.fontSize} onChange={this.handleLineChange(idx)}>
															<option value='12'>12</option>
															<option value='14'>14</option>
															<option value='16'>16</option>
															<option value='18'>18</option>
															<option value='20'>20</option>
															<option value='24'>24</option>
															<option value='28'>28</option>
															<option value='32'>32</option>
															<option value='36'>36</option>
															<option value='40'>40</option>
															<option value='44'>44</option>
															<option value='48'>48</option>
															<option value='72'>72</option>
														</select>
													</div>
													<div className="col-md-4">
														<label>Font Style</label>
														<ul>
															<li className="checkboxWrapper">
																<label className={plaqueLine.bold ? 'active btn' : 'btn'}>
																	<input name={`bold`} onClick={this.handleLineChange(idx)} type="checkbox" checked={plaqueLine.bold} value={`bold`} />
																	<i className={'fa fa-bold'}></i>
																</label>
															</li>
															<li className="checkboxWrapper">
																<label className={plaqueLine.italic ? 'active btn' : 'btn'}>
																	<input name={`italic`} onClick={this.handleLineChange(idx)} type="checkbox" checked={plaqueLine.italic} value={`italic`} />
																	<i className={'fa fa-italic'}></i>
																</label>
															</li>
															<li className="checkboxWrapper">
																<label className={plaqueLine.underline ? 'active btn' : 'btn'}>
																	<input name={`underline`} onClick={this.handleLineChange(idx)} type="checkbox" checked={plaqueLine.underline} value={`underline`} />
																	<i className={'fa fa-underline'}></i>
																</label>
															</li>
														</ul>
													</div>
													{/*<div className="col-md-4">
														<label htmlFor="bottomMargin">Bottom Margin</label>
										        		<input type="number" className="form-control" id="bottomMargin" name="bottomMargin" value={plaqueLine.bottomMargin} onChange={this.handleLineChange(idx)} />
													</div>*/}
													<div className="h-size10 clear"></div>
												</div>
											))}
											<div className="row">
												<div className="col-sm-12">
													<button className="btn btn-primary default-btn" onClick={this.handleAddLine}>{`Add Line ${plaqueLines.length + 1}`}</button>
												</div>
											</div>
										</div>
										<div className="h-size30 clear"></div>
									</div>
								</div>
							</div>
							:
							<div className="row">
								<div className="col-sm-12">
									<div className="alert alert-danger">
										<h4>No plaque for selected layout.</h4>
									</div>
								</div>
							</div>
						}
					</div>
					:
					<div className="row">
						<div className="col-sm-12">
							<Loader />
						</div>
					</div>
				}
			</div>
		);
	}
}
export default Plaque;